import Vue from 'vue'
import App from './App'
import resource from './resource'; //通过import引入
import VueLazyload from 'vue-lazyload';
import HTTP from './assets/js/http.js'; //全局公用http请求
import BASE from './assets/js/global.js'; //全局公用方法
import filters from './filters/filters.js';
import vuescroll from 'vuescroll';
import router from './router'
import VueAwesomeSwiper from 'vue-awesome-swiper'
Vue.use(VueAwesomeSwiper)
import 'swiper/dist/css/swiper.css'

Vue.use(vuescroll, {
    ops: {}, // 在这里设置全局默认配置
    name: 'myScroll' // 在这里自定义组件名字，默认是vueScroll
});
Vue.use(VueLazyload, {
    preload: 1.3, //预加载的宽高
    loading: 'https://i0.ulecdn.com/ulewap/i/290x290x2x.png',
    error: 'https://i0.ulecdn.com/ulewap/i/290x290x2x.png',
    attempt: 3, //尝试加载的次数
    listenEvents: ['scroll', 'wheel', 'mousewheel', 'resize', 'animationend', 'transitionend', 'touchmove'] //你想让vue监听的事件
});
Vue.use(HTTP);

Vue.use(BASE);

// 注册所有的filter
for (let key in filters) {
    Vue.filter(key, filters[key])
}
Vue.config.productionTip = false
new Vue({
    el: '#app',
    resource,
    router,
    components: {
        App
        
    },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js